import { Editor } from 'tinymce';
import QuillEditorSubWrapper from './editor';

export enum QuillEditorIDS {
  RESEARCH_EDITOR = 'RESEARCH_EDITOR',
  GRAMMAR_EDITOR = 'GRAMMAR_EDITOR',
  RESEARCH_SCRATCHPAD = 'RESEARCH_SCRATCHPAD',
  WORD_COUNTER_EDITOR = 'WORD_COUNTER_EDITOR',
}

export default class QuillEditor {
  private static editorInstances: Record<QuillEditorIDS, QuillEditorSubWrapper | undefined> = {
    RESEARCH_EDITOR: undefined,
    GRAMMAR_EDITOR: undefined,
    RESEARCH_SCRATCHPAD: undefined,
    WORD_COUNTER_EDITOR: undefined,
  };

  public static getInstance(id: QuillEditorIDS, editor?: Editor) {
    if (editor && !QuillEditor.editorInstances?.[id]) {
      QuillEditor.editorInstances[id] = new QuillEditorSubWrapper(editor);
    }

    return QuillEditor.editorInstances[id];
  }

  public static removeInstance(id: QuillEditorIDS) {
    if (QuillEditor.editorInstances?.[id]) {
      QuillEditor.editorInstances[id] = undefined;
    }
  }

  public static fire(id: QuillEditorIDS, eventName: string) {
    if (QuillEditor.editorInstances?.[id]) {
      QuillEditor.editorInstances[id]?.fire(eventName);
    }
  }
}
